<template>
  <div>
    <div>Start</div>
    <div style="float:right" @click="signOut()">Sign Out</div>
  </div>
</template>

<script>
import Auth from '@/plugins/Auth'
export default {
  /* eslint-disable */
  created() {
  },
  methods: {
    signOut: function() {
      Auth.signOut()
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/Start.vue